import { render } from "./custom-nav.vue?vue&type=template&id=00286aef"
import script from "./custom-nav.vue?vue&type=script&lang=js"
export * from "./custom-nav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__